/**
 * @generated SignedSource<<9f90c735f52c8e41902c443ba71b2a9f>>
 * @relayHash e417b25e38c5da02aa0ed155243055ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0b45ac4ddbcd2a0156fe3af9d36d55e01ea6443157d4e345993be7fc0bca2e7b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0b45ac4ddbcd2a0156fe3af9d36d55e01ea6443157d4e345993be7fc0bca2e7b",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
